import React from "react";

interface McqOptionsProps {
  questionType: string;
  options: any[];
  selectedOptionIndex: number[];
  answers:number[],
  isSubmitted: boolean;
  disable: boolean;
  setSelectedOptionIndex: React.Dispatch<
    React.SetStateAction<number | number[]>
  >;
}

const McqOptions: React.FC<McqOptionsProps> = ({
  questionType,
  options,
  selectedOptionIndex,
  isSubmitted,
  disable,
  answers,
  setSelectedOptionIndex,
}) => {
  const isMultiple = questionType === "MULTIPLE";

  return (
    <div className="mcq-options">
      {options.map((option, idx) => {
        const isSelected = selectedOptionIndex.includes(idx)

        return (
          <label
            key={idx}
            className={`${option.image_endpoint ? "image-option-btn" : "option-button"} 
              ${isSelected ? "selected" : ""} 
              ${
                isSubmitted &&  isSelected ? answers.includes(idx)
                  ? "correct"
                  : "incorrect" : ""
              } 
              ${disable ? "disabled" : ""}`}
          >
            {/* Small checkbox for MULTIPLE */}
            <input
              type={isMultiple ? "checkbox" : "radio"}
              name={`question-${idx}`}
              value={idx}
              disabled={disable}
              checked={isSelected}
              onChange={() => {
                if (disable) return;

                if (isMultiple) {
                  setSelectedOptionIndex((prev) => {
                    const prevArray = Array.isArray(prev) ? prev : [];
                    return prevArray.includes(idx)
                      ? prevArray.filter((i) => i !== idx)
                      : [...prevArray, idx];
                  });
                } else {
                  setSelectedOptionIndex([idx]);
                }
              }}
              className={isMultiple ? "small-checkbox" : ""}
            />

            {/* Option text */}
            {option.value && <span>{option.value}</span>}

            {/* Option image */}
            {option.image_endpoint && (
              <img
                src={option.image_endpoint}
                alt=""
                className="option-image"
              />
            )}
          </label>
        );
      })}
    </div>
  );
};

export default McqOptions;
